var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pills',{attrs:{"filtro":_vm.filtro}}),_c('div',[(_vm.available == true)?_c('VueApexCharts',{attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }